module.exports = __webpack_public_path__ + "img/contact-icon.2516fbe1.png";